import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UtilsService {
  getWhatsappUrl(whatsapp: string): string {
    if (!whatsapp) return '';
    if (whatsapp.startsWith('http')) return whatsapp;
    const num = whatsapp.replace(/\D/g, '');
    return `https://wa.me/${num}`;
  }

  getYoutubeUrl(url: string): string {
    if (!url) return '';
    if (url.startsWith('http')) return url;
    return 'https://' + url.replace(/^\/+/, '');
  }

  getTagClass(val: string): string {
    if (!val) return '';
    return val
      .toLowerCase()
      .normalize('NFD')
      .replace(/\p{Diacritic}/gu, '')
      .replace(/\s/g, '');
  }

  sortArray(
    arr: any[],
    key: string,
    type: string = 'alpha',
    reverse = false,
  ): any[] {
    return arr.sort((a: any, b: any) => {
      let valA = a[key];
      let valB = b[key];

      if (type === 'date') {
        const parseDate = (d: string) => {
          if (!d) return new Date(0);
          if (/^\d{4}-\d{2}-\d{2}/.test(d)) return new Date(d);
          if (/^\d{2}\/\d{2}\/\d{4}/.test(d)) {
            const [day, month, year] = d.split('/');
            return new Date(+year, +month - 1, +day);
          }
          return new Date(d);
        };
        valA = parseDate(valA);
        valB = parseDate(valB);
        if (valA < valB) return reverse ? 1 : -1;
        if (valA > valB) return reverse ? -1 : 1;
        return 0;
      }

      if (type === 'valor') {
        valA = Number(valA) || 0;
        valB = Number(valB) || 0;
      } else {
        valA = (valA || '').toString().toLowerCase();
        valB = (valB || '').toString().toLowerCase();
      }

      if (valA < valB) return reverse ? 1 : -1;
      if (valA > valB) return reverse ? -1 : 1;
      return 0;
    });
  }

  getFiltroValor(filtros: any[], grupo: string): any {
    const filtro = filtros.find((f) => f.filtroGrupo === grupo);
    if (!filtro) return undefined;
    return typeof filtro.filtroID === 'string'
      ? Number(filtro.filtroID)
      : filtro.filtroID;
  }

  getFiltroValores(filtros: any[], grupo: string): any[] {
    return filtros
      .filter((f) => f.filtroGrupo === grupo)
      .map((f) => f.filtroID);
  }

  applyPhoneMask(phone: string): string {
    const numbers = phone.replace(/\D/g, '');

    if (numbers.length === 11) {
      return numbers.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
    } else if (numbers.length === 10) {
      return numbers.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
    }

    return phone;
  }

  formatPhoneOnInput(value: string): string {
    let cleaned = value.replace(/\D/g, '');

    if (cleaned.length > 11) {
      cleaned = cleaned.substring(0, 11);
    }

    if (cleaned.length > 6) {
      return cleaned.replace(/(\d{2})(\d{5})(\d{0,4})/, '($1) $2-$3');
    } else if (cleaned.length > 2) {
      return cleaned.replace(/(\d{2})(\d{0,5})/, '($1) $2');
    } else if (cleaned.length > 0) {
      return cleaned.replace(/(\d{0,2})/, '($1');
    }

    return cleaned;
  }

  removePhoneMask(phone: string): string {
    return phone.replace(/\D/g, '');
  }

  validateEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }
}
